module.exports = __webpack_public_path__ + "img/em-pros-06.a52df245.png";